import React from "react";
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend
} from "recharts";
import ReactECharts from "echarts-for-react";

const LOW_STOCK_THRESHOLD = 0.2;

const MyProjectInventoryCharts = ({ data }) => {
    // Aggregate by project for bar chart
    const projectDataMap = {};
    data.forEach(item => {
        const project = item.issuedToProject?.projectTitle || "Other";
        if (!projectDataMap[project]) projectDataMap[project] = { project, consumed: 0, returned: 0, remaining: 0 };
        projectDataMap[project].consumed += item.quantityConsumed || 0;
        projectDataMap[project].returned += item.quantityReturned || 0;
        projectDataMap[project].remaining += item.quantityIssued - (item.quantityConsumed || 0) - (item.quantityReturned || 0);
    });
    const projectChartData = Object.values(projectDataMap);

    // Low stock treemap: projects as parent, items as children
    const lowStockMap = {};
    data.forEach(item => {
        const remainingQty = item.quantityIssued - (item.quantityConsumed || 0) - (item.quantityReturned || 0);
        const remainingPercent = remainingQty / item.quantityIssued;
        if (remainingPercent < LOW_STOCK_THRESHOLD) {
            const project = item.issuedToProject?.projectTitle || "Other";
            if (!lowStockMap[project]) lowStockMap[project] = { name: project, children: [] };
            lowStockMap[project].children.push({
                name: item.itemName,
                value: remainingQty,
                itemCategory: item.itemCategory
            });
        }
    });
    const treemapData = Object.values(lowStockMap);

    const treemapOptions = {
        tooltip: {
            formatter: info => `${info.name} (${info.data.itemCategory || 'Category'}): ${info.value}`
        },
        series: [
            {
                type: 'treemap',
                roam: false,
                label: { show: true, formatter: '{b}', fontSize: 12, color: '#000' },
                upperLabel: { show: true, height: 30 },
                data: treemapData
            }
        ]
    };

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
            {/* Bar chart by project */}
            <div className="bg-white p-6 rounded-2xl shadow-md overflow-x-auto">
                <h3 className="text-xl font-semibold mb-4">Quantity by Project</h3>
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={projectChartData} margin={{ top: 20, right: 30, left: 0, bottom: 80 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                            dataKey="project"
                            tick={{ fontSize: 12 }}
                            interval={0}
                            height={60}
                            tickFormatter={(text) => text.length > 15 ? text.slice(0, 12) + '...' : text}
                        />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="remaining" stackId="a" fill="#10b981" name="Remaining" />
                        <Bar dataKey="consumed" stackId="a" fill="#f59e0b" name="Consumed" />
                        <Bar dataKey="returned" stackId="a" fill="#3b82f6" name="Returned" />
                    </BarChart>
                </ResponsiveContainer>
            </div>

            {/* Treemap for low stock */}
            <div className="bg-white p-6 rounded-2xl shadow-md">
                <h3 className="text-xl font-semibold mb-4">Low Stock Items</h3>
                <ReactECharts option={treemapOptions} style={{ height: '300px' }} />
            </div>
        </div>
    );
};

export default MyProjectInventoryCharts;
